/**
 * SidePanel Component
 *
 * Main navigation panel container that renders:
 * - Desktop sidebar (SidebarDesktop) for large screens with collapse support
 * - Mobile icon sidebar (SidebarMobileCollapsed) for small screens
 *
 * Uses isMobileView from NavigationProvider to determine which to render
 *
 * @module SidePanel
 */

import React from 'react';
import { useSidebar } from '../hooks/useSidebar';
import SidebarDesktop from './SidebarDesktop';
import SidebarMobile from './SidebarMobile';
import SidebarMobileCollapsed from './SidebarMobileCollapsed';

/**
 * SidePanel - Main navigation container
 *
 * Automatically switches between desktop and mobile layouts
 * based on screen size and NavigationProvider state
 */
const SidePanel = () => {
  const { isMobileView, isSidebarOpen, closeSidebar } = useSidebar();

  // Mobile: Always show collapsed icon-only sidebar
  if (isMobileView) {
    return (
      <>
        <SidebarMobileCollapsed />
        <SidebarMobile isOpen={isSidebarOpen} onClose={closeSidebar} />
      </>
    );
  }

  // Desktop: Collapsible sidebar
  return <SidebarDesktop />;
};

SidePanel.propTypes = {};

export default SidePanel;
